import { memo } from "react";

import { UploadManagerProvider } from "@hl/base-components/lib/upload/context";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks/useFeatureFlags";

import { CreateCollectionContextProvider } from "~/features/collections/forms/CreateCollectionMultistepForm/context";
import FeatureNotAvailable from "~/features/layout/FeatureNotAvailable";

import CreateCollectionMultistepForm from "../forms/CreateCollectionMultistepForm";

const CreateTokenWizard = () => {
  const enableNewCreate = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_INHOTIM_NEW_COLLECTION_UX
  );

  if (!enableNewCreate) {
    return <FeatureNotAvailable />;
  }

  return (
    <CreateCollectionContextProvider>
      <UploadManagerProvider>
        <CreateCollectionMultistepForm />
      </UploadManagerProvider>
    </CreateCollectionContextProvider>
  );
};

export default memo(CreateTokenWizard);
